const api = {
  get: function(url, opts) {
    // make sure we have value of opts.
    if (opts === null) {
      opts = {
        method: "GET"
      };
    }

    return fetch(url, opts);
  },
  post: function(url, opts) {
    if (opts === null) {
      opts = {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        },
        body: JSON.stringify({})
      };
    }
    return fetch(url, opts);
  },
  patch: function(url, opts) {
    if (opts === null) {
      opts = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        },
        body: JSON.stringify({})
      };
    }

    return fetch(url, opts);
  }
};

export default api;
